var map = {
	"./boardBackgroundPrompt.json": "./app/common/lib/experiments/config/boardBackgroundPrompt.json",
	"./moonshotDirectSignup.json": "./app/common/lib/experiments/config/moonshotDirectSignup.json",
	"./notificationsLayout.json": "./app/common/lib/experiments/config/notificationsLayout.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/common/lib/experiments/config sync \\.json$";